"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_photo_collage_container_1 = require("./react-photo-collage/react-photo-collage-container");
exports.ReactPhotoCollage = react_photo_collage_container_1.default;
//# sourceMappingURL=index.js.map